import IconButton from "@/components/common/GoogleIconButton";
import { cn } from "@/lib/utils";
import Chip from "@mui/material/Chip";
import { Loader2, X } from "lucide-react";
import type { PendingFile } from "./useChatAttachments";
export function ChatPendingFiles({
  files: pendingFiles,
  onRemove: removeFile,
}: {
  files: PendingFile[];
  onRemove: (index: number) => void;
}) {
  return (
    <>
      {pendingFiles.length > 0 && (
        <div
          className="flex gap-2 mb-2 overflow-x-auto whitespace-nowrap scrollbar-none"
          role="list"
          aria-label="Pending files"
        >
          {pendingFiles.map((pf, i) => (
            <Chip
              key={i}
              size="small"
              role="listitem"
              color={pf.error ? "error" : undefined}
              className={cn("shrink-0", pf.uploading && "opacity-70")}
              label={
                <span className="flex items-center gap-1">
                  <span className="max-w-[80px] sm:max-w-[160px] truncate inline-block align-middle">
                    {pf.file.name}
                  </span>
                  {pf.uploading && (
                    <Loader2 className="h-2.5 w-2.5 animate-spin inline-block align-middle" />
                  )}
                  {pf.error && (
                    <span className="text-xs ml-1">({pf.error})</span>
                  )}
                </span>
              }
              onDelete={!pf.uploading ? () => removeFile(i) : undefined}
              deleteIcon={
                !pf.uploading ? (
                  <IconButton
                    type="submit"
                    size="small"
                    aria-label={`Remove ${pf.file.name}`}
                    sx={{
                      width: 18,
                      height: 18,
                      minWidth: 18,
                      borderRadius: "9999px",
                      "& svg": { color: "inherit" },
                    }}
                  >
                    <X className="h-3 w-3" />
                  </IconButton>
                ) : undefined
              }
              sx={{
                gap: "0.25rem",
                paddingRight: "0.25rem",
                "& .MuiChip-label": { paddingRight: "0.25rem" },
              }}
            />
          ))}
        </div>
      )}
    </>
  );
}
